module.exports = __webpack_public_path__ + "img/mini.27a5e8fd.png";